import { Button, DataSource, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDistanceSource extends Layout {
    buttonDistancePreferences: Button;
    buttonUpdateCityFiles: Button;
    labelDistanceProfile: Label;
    labelDistanceVersions: Label;
    labelTrimblePlacesOptions: Label;
    labelUpdatePCMilerCityFiles: Label;
    panelDistanceVersions: Panel;
    panelTrimble: Panel;
    panelUpdateCityFiles: Panel;
    sourceDispatchControl: DataSource;
    sourceDistanceProfileControl: DataSource;
    sourceDistanceSource: DataSource;
    sourceDistanceVersion: DataSource;
    switchAdditionalUpdateCitySettings: Switch;
    switchAllowDuplicateLocationCreationTrimble: Switch;
    switchCreateLocationFromStopTrimble: Switch;
    switchDistanceVersions: Switch;
    switchEnableAddCustomerTrimble: Switch;
    switchEnableAddLocationTrimble: Switch;
    switchEnableStopLookupTrimble: Switch;
    switchEnableTrimblePlaces: Switch;
    switchExecuteUpdates: Switch;
    switchOrderHistoryRecords: Switch;
    switchPrintEditList: Switch;
    switchStreetLevel: Switch;
    switchTollsCapable: Switch;
    switchUpdateLocation: Switch;
    switchUpdateStops: Switch;
    tableDistanceProfiles: Table;
    tableDistanceVersions: Table;
    textboxConnectionTimeout: Textbox;
    textboxDistanceVendorOptions: Textbox;
    textboxMileMakerApiKey: Textbox;
    textboxPcMilerUpdateVersion: Textbox;
    textboxTrimblePlacesEntryDelay: Textbox;
    textboxUpdateType: Textbox;
    textboxWebserviceApiKey: Textbox;
    textboxWebserviceOptionLevel: Textbox;
    textboxWebserviceUrl: Textbox;
}
